import type { Command } from "./types.js";

/**
 * Holds registered commands and looks them up by name.
 *
 * Names are matched exactly. Registering two commands with the same name
 * is an error — the second call throws. Callers that want to override an
 * existing command must `unregister` first.
 */
export class CommandRegistry {
  private readonly commands = new Map<string, Command>();

  register(command: Command): void {
    if (this.commands.has(command.name)) {
      throw new Error(`Command "${command.name}" is already registered`);
    }
    this.commands.set(command.name, command);
  }

  unregister(name: string): boolean {
    return this.commands.delete(name);
  }

  has(name: string): boolean {
    return this.commands.has(name);
  }

  get(name: string): Command | undefined {
    return this.commands.get(name);
  }

  list(): readonly Command[] {
    return Array.from(this.commands.values());
  }
}
